import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SensorStatusTable from '../components/tables/SensorStatusTable.tsx';

type Props = {
  isAdmin: boolean;
};

export default function SensorStatus({ isAdmin }: Props) {
  return (
    <Box sx={{ p: '0 1.5rem 2.5rem', height: '100vh', width: '75vw', margin: '0 auto' }}>

      {/* Header */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
        <Typography sx={{
          fontFamily: "'Syne', sans-serif",
          fontSize: 20,
          fontWeight: 600,
          color: 'var(--color-text-primary)',
        }}>
          Sensor Status
        </Typography>
      </Box>

      {/* Table panel */}
      <Box sx={{
        background:   'var(--color-bg-secondary)',
        borderRadius: 3,
        p:            '1.25rem 1.5rem',
      }}>
        <SensorStatusTable isAdmin={isAdmin} />
      </Box>
    </Box>
  );
}
